var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.0001C10.8954 2.0001 10 2.89553 10 4.0001C10 4.55238 9.55228 5.00009 9 5.00009C8.44771 5.00009 8 4.55238 8 4.00009C8 3.99901 8 3.99794 8 3.99686C8.00175 1.7892 9.79195 9.15527e-05 12 9.15527e-05C14.2091 9.15527e-05 16 1.79096 16 4.0001C16 5.75229 14.874 7.2389 13.3091 7.7807C13.186 7.82331 13.0903 7.89024 13.0372 7.949C13.0114 7.97754 13.0026 7.99527 13 8.00279V9.4764L22.3428 15.9445C24.4195 17.3822 24.1965 20.5196 21.9373 21.6492C21.4759 21.88 20.9671 22.0001 20.4511 22.0001H3.54803C3.03211 22.0001 2.52327 21.88 2.06182 21.6492C-0.197369 20.5196 -0.420344 17.3822 1.6564 15.9445L11 9.47582V8.00011C11 6.84759 11.9238 6.14383 12.6547 5.89077C13.4391 5.6192 14 4.87386 14 4.0001C14 2.89553 13.1046 2.0001 12 2.0001ZM11.9996 11.2163L2.79482 17.5889C1.9679 18.1614 2.05668 19.4106 2.95625 19.8604C3.13999 19.9523 3.3426 20.0001 3.54803 20.0001H20.4511C20.6566 20.0001 20.8592 19.9523 21.0429 19.8604C21.9425 19.4106 22.0313 18.1613 21.2043 17.5889L11.9996 11.2163Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger);
export default __webpack_public_path__ + "static/media/hanger.8aa707b18da6923e782e5d1c44d66f77.svg";
export { ForwardRef as ReactComponent };